export const INIT_HOMEPAGE = 'INIT_HOMEPAGE';
export const INIT_LASTPAGE = 'INIT_LASTPAGE';